const BURGER_SELECTOR =  '.burger, .btm-panel-cetegs';
const BODY_SELECTOR = 'body';
const EXPANDABLE_MENUITEM_SELECTOR = '.menu-item__expandable';
const EXPANDED_HEADER_SELECTOR = '.menu-expanded__header_mobile';
const EXPANDED_MENU_SELECTOR = '.menu-expanded';
const MENU_ITEM_SELECTOR = '.menu-item';
const MAIN_MENU_ITEM_SELECTOR = '.main-menu ' + MENU_ITEM_SELECTOR;
const WIDTH_LG = 1024;
const WIDTH_BLOCK_MENU = 281;

const MENU_OPEN_CLS = 'menu-opened';
const MENU_ITEM_ACTIVE_CLS = 'menu-item_active';

jQuery(EXPANDED_HEADER_SELECTOR).on('touchstart click', function (e) {
  e.preventDefault();
  e.stopPropagation();
  jQuery(MAIN_MENU_ITEM_SELECTOR + '.' + MENU_ITEM_ACTIVE_CLS).removeClass(MENU_ITEM_ACTIVE_CLS);
});

jQuery(".main-menu__title").on('touchstart click', function (e) {
  e.preventDefault();
  e.stopPropagation();
});

jQuery(MAIN_MENU_ITEM_SELECTOR).on('click', function (e) {
  if(jQuery(EXPANDABLE_MENUITEM_SELECTOR, this).length > 0 
  	&& !jQuery(this).hasClass(MENU_ITEM_ACTIVE_CLS)
  	&& document.body.scrollWidth <= WIDTH_LG)
  {
    e.preventDefault();
    e.stopPropagation();
    resetActive();
    jQuery(this).closest(MENU_ITEM_SELECTOR).addClass(MENU_ITEM_ACTIVE_CLS);
  }
});

function resetActive(){
  jQuery(MAIN_MENU_ITEM_SELECTOR + '.' + MENU_ITEM_ACTIVE_CLS).removeClass(MENU_ITEM_ACTIVE_CLS);
}

function closeMainMenu(){
  jQuery(BODY_SELECTOR).toggleClass(MENU_OPEN_CLS);
  if(jQuery(BODY_SELECTOR).hasClass(MENU_OPEN_CLS)){
    jQuery('.menu-expanded__header_mobile').each(function () {
      jQuery(this).closest('.' + MENU_ITEM_ACTIVE_CLS).removeClass(MENU_ITEM_ACTIVE_CLS);
    });
  }	
}


jQuery(".page__menu").click(function(e){
	if(document.body.scrollWidth <= WIDTH_LG && e.offsetX > WIDTH_BLOCK_MENU) {
		closeMainMenu();
	}
});

jQuery(BURGER_SELECTOR).click(function () {
  closeMainMenu();
});

jQuery('body').click(function (e) {
  if(jQuery(this).closest(MENU_ITEM_SELECTOR).length === 0){
    resetActive();
  }
});
